import React from 'react';
import {StyleSheet, View} from 'react-native';
import Text from '../../../components/Text';
import {
  FilterArguments,
} from '../alertsReducer';
import {makeId} from '../../../utils';

export default function ActiveFiltersSection(props: {
    filterArgs: FilterArguments;
    units: Array<{name: string; id: string}>;
  }) {
    const items: Array<{label: string | any; key: string}> = [];
  
    for (const key in props?.filterArgs) {
      if (Object.prototype.hasOwnProperty.call(props?.filterArgs, key)) {
        let label = props?.filterArgs[key];
        if (label !== null && label !== '') {
          if (key === 'unit') {
            label =
              props?.units?.find(unit => unit.id === label)?.name ??
              'Unknown unit';
          }
          if (key === 'startDate' || key === 'endDate') {
            label = new Date(label).toLocaleString();
          }
          items.push({label, key});
        }
      }
    }
  
    if (items.length > 0) {
      return (
        <View style={styles.container}>
          <Text style={styles.title}>Active filters</Text>
          <View style={styles.chips}>
            {items.map(item => (
              <View style={styles.chip} key={makeId(16)}>
                <Text style={styles.chipText}>
                  {`${formatFilterKey(item.key)}: ${item.label}`}
                </Text>
              </View>
            ))}
          </View>
        </View>
      );
    } else {
      return null;
    }
  }

const formatFilterKey = (key: string) => {
  switch (key) {
    case 'startDate':
      return 'From';
    case 'endDate':
      return 'To';
    case 'eventName':
      return 'Event';
    default:
      return key.charAt(0).toUpperCase() + key.slice(1);
  }
};

const styles = StyleSheet.create({
  container: {
    marginHorizontal: 12,
    marginBottom: 8,
    paddingTop: 2,
  },
  title: {
    color: '#52525b',
    fontSize: 12,
    fontWeight: '600',
    marginBottom: 6,
  },
  chips: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 6,
  },
  chip: {
    backgroundColor: '#e0f2fe',
    borderColor: '#bae6fd',
    borderRadius: 6,
    borderWidth: 1,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
  chipText: {
    color: '#075985',
    fontSize: 12,
    fontWeight: '500',
  },
});
